module.exports = {
        srcSet: __webpack_public_path__ + "static/media/letter-664.396d97eb.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/letter-664.396d97eb.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/letter-664.396d97eb.webp",
        toString: function(){return __webpack_public_path__ + "static/media/letter-664.396d97eb.webp"},
        
        width: 664,
        height: 664
      }